import ChartContainer from '../Services/charts/apex-charts/ChartContainer';
import { defaultColors } from '../Services/contexts/ServicesChartsDataContext';

export const LineChart = ({ title, values, subtitles, category, height = 350, className = '', colors = defaultColors }) => {
    const series = Array.isArray(category)
        ? category.map((item, index) => ({ name: item, data: values[index] }))
        : [{ name: category, data: values }];

    const options = {
        colors,
        chart: {
            type: 'line',
            height,
            toolbar: {
                show: true
            },
            animations: {
                enabled: true,
                easing: 'easeinout',
                speed: 2000
            }
        },
        stroke: {
            curve: 'smooth',
            width: 3
        },
        xaxis: {
            categories: subtitles,
            axisBorder: {
                show: true,
                color: '#333'
            },
            axisTicks: {
                show: true,
                color: '#333'
            },
            labels: {
                style: {
                    fontSize: '14px',
                    colors: '#333'
                }
            }
        },
        yaxis: {
            labels: {
                formatter: (val) => (val || val === 0 ? val.toLocaleString('pt-BR') : '')
            }
        },
        legend: {
            show: true,
            position: 'bottom',
            markers: {
                shape: 'square'
            },
            labels: {
                useSeriesColors: true,
                style: {
                    fontSize: '14px'
                }
            }
        },
        tooltip: {
            theme: 'light',
            style: {
                fontSize: '14px'
            },
            y: {
                formatter: (val) => (val || val === 0 ? val.toLocaleString('pt-BR') : '')
            }
        },
        grid: {
            show: true,
            borderColor: '#e0e0e0',
            xaxis: {
                lines: {
                    show: false
                }
            },
            yaxis: {
                lines: {
                    show: true
                }
            }
        }
    };

    return (
        <ChartContainer
            title={title}
            options={options}
            series={series}
            type="line"
            height={height}
            className={className}
        />
    );
};
